module.exports = __webpack_public_path__ + "static/media/buyAndShipForMe.e098ee57.png";